import { OnInit, Input, EventEmitter, Output, Component } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { RemarksPopup } from "./RemarksPopup";

@Component({
    selector: 'RemarksPopupTrigger',
    templateUrl: './RemarksPopupTrigger.html'
})
export class RemarksPopupTrigger implements OnInit {
    @Input() Model: string;
    @Output() ModelChange = new EventEmitter<string>();

    @Input() EnableMaxLimit = false;

    constructor(public modalService: NgbModal) {}

    ngOnInit() { }

    DidTapTrigger() {

        const modal: NgbModalRef = this.modalService.open(RemarksPopup, {
            centered: true,
            size: 'lg',
            backdrop: 'static'
        });

        const popup: RemarksPopup = modal.componentInstance;

        setTimeout(() => {
            popup.SetModel(this.Model || '', this.EnableMaxLimit);
        }, 100);


        modal.result.then((value: string) => {
            this.ModelChange.emit(value);
        });
    }
}
